export const SIGNUP = "@@SECURITY_FUND/SIGNUP";
export const SIGN_OUT_USER = "@@SECURITY_FUND/SIGN_OUT_USER";

export const actionCreators = {
  signUp: (payload) => ({
    type: SIGNUP,
    payload,
  }),
  signOut: () => ({
    type: SIGN_OUT_USER,
  }),
};
